import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { 
    AppBar, Toolbar, Typography, Button, Box, IconButton, 
    Menu, MenuItem, Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText 
} from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useAuth } from '../../contexts/AuthContext';
import BellNotifications from '../common/BellNotifications';
import MailIcon from '@mui/icons-material/Mail';
// import logo from '../../assets/logo.png';

function Header() {
  const { currentUser, token, logout } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false); // State for confirmation dialog

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenConfirm = () => {
    setConfirmOpen(true);
    handleClose(); // Close the menu when opening the dialog
  };

  const handleCloseConfirm = () => {
    setConfirmOpen(false);
  };

  const handleLogout = () => {
    handleCloseConfirm();
    logout();
    navigate('/');
  };

  const handleProfile = () => {
    handleClose();
    navigate('/profile');
  };

  return (
    <>
      <AppBar position="static">
        <Toolbar>
          <Box 
            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', flexGrow: 1 }} 
            onClick={() => navigate('/')}
          >
            {/* <img src={logo} alt="Site Logo" style={{ height: '40px', marginRight: '10px' }} /> */}
            <Typography variant="h6">
              Lost & Found
            </Typography>
          </Box>

          {/* <Button color="inherit" onClick={() => navigate('/')}>Home</Button> */}
          <Button color="inherit" onClick={() => navigate('/blog')}>Blog</Button> {/* <-- కొత్త లింక్‌ను జోడించండి */}

          
          {token && (
              <>
                  <IconButton color="inherit" onClick={() => navigate('/inbox')}>
                      <MailIcon />
                  </IconButton>
                  <BellNotifications />
                  <IconButton
                      size="large"
                      onClick={handleMenu}
                      color="inherit"
                  >
                      <AccountCircle />
                  </IconButton>
                  <Menu
                      anchorEl={anchorEl}
                      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                      keepMounted
                      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                  >
                      <MenuItem disabled>Welcome, {currentUser?.username}</MenuItem>
                      <MenuItem onClick={handleProfile}>Profile</MenuItem>
                      {currentUser?.isAdmin && <MenuItem onClick={() => { handleClose(); navigate('/admin/dashboard'); }}>Admin Panel</MenuItem>}
                      <MenuItem onClick={handleOpenConfirm}>Logout</MenuItem>
                  </Menu>
              </>
          )}

          {!token && (
              <>
                  <Button color="inherit" onClick={() => navigate('/')}>Home</Button>
                  <Button color="inherit" onClick={() => navigate('/login')}>Login</Button>
              </>
          )}
        </Toolbar>
      </AppBar>

      {/* Logout Confirmation Dialog */}
      <Dialog
        open={confirmOpen}
        onClose={handleCloseConfirm}
      >
        <DialogTitle>Confirm Logout</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirm}>Cancel</Button>
          <Button onClick={handleLogout} color="primary" autoFocus>
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Header;